import { render, staticRenderFns } from "./educationEdit.vue?vue&type=template&id=358d0829"
import script from "./educationEdit.vue?vue&type=script&lang=js"
export * from "./educationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358d0829')) {
      api.createRecord('358d0829', component.options)
    } else {
      api.reload('358d0829', component.options)
    }
    module.hot.accept("./educationEdit.vue?vue&type=template&id=358d0829", function () {
      api.rerender('358d0829', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationEdit.vue"
export default component.exports